import { Redirect, Route, Switch, Router } from 'react-router-dom';
import { history } from '../store';
import Investors from '../components/investors';
import OnboardingRouter from '../components/onboarding/Router';
import MobileLogin from '../components/auth/MobileLogin';
import LoginOtp from '../components/auth/loginOtp';
import RedirectRoute from './RedirectRoute';
import ProtectedRoute from './ProtectedRoute';
import ApplicationRoutes from '../components/investors/routes';
import Profile from '../components/profile/index';
import ApplicationDetails from '../components/ApplicationDetails/index';
import { useEffect } from 'react';
import { useSnackbar, VariantType } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../redux-store/reducers';
import InvestorRoutes from '../components/Investments/routes';
import UserManagementLayOut from '../components/userManagement/router';
import { USER_ROLES } from '../utils/constant';
import { FundsSetup } from '../components/FundsSetup';
import { RiskProfile } from '../components/RiskProfile';
import { AMCAdminsList } from '../components/AmcAdmins';
import ApplicationEsignList from '../components/ApplicationsEsignList';
import { CLEAR_GLOBAL_ERROR } from '../redux-store/types/auth';
import { useModal } from 'mui-modal-provider';
import SimpleDialog from '../components/commonComponents';
import NonIndividualApplicationRoutes, {
  NonIndividualApplicationEdit,
} from '../components/NonIndividualInvestor/routes';
import Reports from '../components/Reports/reports';
import { NonIndividualApplicationDetail } from '../components/NonIndividualApplicationDetails';
import ConsentEmailApproveReject, {
  ConsentEmailApplicationsList,
  ConsentEmailApprove,
  ConsentEmailReject,
} from '../components/ConsentEmailComponent';
import adminSupport from '../components/adminSupport';
import LoginRequireRoute from './LoginRequireRoute';
import Dashboard from '../components/dashboard';
import InvestorDashboard from '../components/dashboard/investor-dashboard';
import InvestorDetails from '../components/dashboard/investor-details';
import TotalRmDetail from '../components/dashboard/total-rm-detail';
import BookSizeDetail from '../components/dashboard/book-size-details';
import NetSales from '../components/dashboard/net-sales';
import TotalRevenue from '../components/dashboard/total-revenue';
import GrossSales from '../components/dashboard/gross-sales';
import IndividualInvestor from '../components/dashboard/individual-investor';
import ProductDetails from '../components/dashboard/product-details';
import DirectEquity from '../components/dashboard/direct-equity/direct-equity';
import { getRmDetails } from '../redux-store/actions/userManagement';
import PMS from '../components/dashboard/pms/pms';
import InvestorReportRoute from '../components/InvestorReport/routesReport';
import AIF from '../components/dashboard/aif';
import Bonds from '../components/dashboard/bonds/index';
import InvestorTransactions from '../components/dashboard/investor-transaction/investor-transactions';
import DashboardReportRoute from '../components/dashboard/Reports_Dashboard/routes';
import documentDownload from '../components/dashboard/downloads/documentDownload'
import { formatDate } from '../utils/utilityFunctions';
import RecommendedSchemes from '../components/dashboard/investor-transaction/recommended-schemes'
import Holding from '../components/dashboard/investor-transaction/holdings'
import STP_SWP from '../components/dashboard/investor-transaction/STP-SWP'
import SwitchComp from '../components/dashboard/investor-transaction/Switch'
import Redeem from '../components/dashboard/investor-transaction/Redeem'
import SIPLumpsum from '../components/dashboard/investor-transaction/SIP-Lumpsum'
import SIP from '../components/dashboard/investor-transaction/SIP-Lumpsum'
import Orders from '../components/dashboard/investor-transaction/orders'
import Mandates from '../components/dashboard/investor-transaction/mandates';
import RiskAssessmentProfile from '../components/dashboard/risk-assessment/risk-profile';
import investorRiskLogin from '../components/dashboard/risk-assessment/investor-login';
import InvestorRiskMobileOtp from '../components/dashboard/risk-assessment/investor-otp';
import RiskProfileDetails from '../components/dashboard/risk-assessment/investor-risk-profile';
import InvestorRiskProfileDetails from '../components/dashboard/risk-assessment/investor-risk-profile';
import RiskProfilePage from '../components/dashboard/risk-assessment/investor-risk-profile';
import InvestmentPreferenceRisk from '../components/dashboard/risk-assessment/investment-preference';
import FinalPage from '../components/dashboard/risk-assessment/final-page';

function AppRoutes(): JSX.Element {
  const dispatch = useDispatch();
  const { toaster, message, severity } = useSelector((state: RootStateType) => state.toast);
  const { id: userId, role = '' } = useSelector((state: RootStateType) => state.auth);
  const { enqueueSnackbar } = useSnackbar();
  const { showModal } = useModal();
  const errorState = useSelector((store: RootStateType) => store.error);
  useEffect(() => {
    toaster && enqueueSnackbar(message, { variant: severity as VariantType });
  }, [toaster]);

  useEffect(() => {
    if (errorState) {
      const { error = '' } = errorState;
      const { destroy } = showModal(SimpleDialog, {
        content: error,
        actions: [
          {
            label: 'OK',
            onClick: () => {
              destroy();
              dispatch({ type: CLEAR_GLOBAL_ERROR });
            },
          },
        ],
      });
    }
  }, [errorState]);

  useEffect(() => {
    if (userId && role === USER_ROLES.RM) {
      dispatch(getRmDetails());
    }
  }, [userId]);

  const getBaseRoute = () => {
    if ([USER_ROLES.RM, USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR].includes(role)) {
      // return '/applications';
      return '/dashboard';
    } else if (
      [
        USER_ROLES.TRUSTEE,
        USER_ROLES.FUND_MANAGER,
        USER_ROLES.POAAPPROVER,
        USER_ROLES.AMCAPPROVER,
      ].includes(role)
    ) {
      return '/applications-list';
    } else if ([USER_ROLES.AMC_ADMIN].includes(role)) {
      // return '/dashboard';
      return '/user-management';
    } else {
      return '/applications';
    }
  };

  return (
    <Router history={history}>
      <Switch>
        <Route
          exact
          path="/"
          render={(props: any) => (
            <Redirect {...props} to={getBaseRoute()} from={props.location.pathname} />
          )}
        />
        <RedirectRoute path="/login" component={MobileLogin} />
        <RedirectRoute path="/verify-otp" component={LoginOtp} />
        <ProtectedRoute path="/dashboard" component={Dashboard} acceptedRoles={[USER_ROLES.RM]} />
        <Route path="/product">
          <Switch>
            <Route exact path="/product" render={() => <Redirect to="/product/mutual-fund" />} />
            <ProtectedRoute
              path="/product/mutual-fund"
              component={ProductDetails}
              acceptedRoles={[USER_ROLES.RM]}
            />
            <ProtectedRoute
              path="/product/direct-equity"
              component={DirectEquity}
              acceptedRoles={[USER_ROLES.RM]}
            />
            <ProtectedRoute
              path="/product/bonds"
              component={Bonds}
              acceptedRoles={[USER_ROLES.RM]}
            />
            <ProtectedRoute path="/product/pms" component={PMS} acceptedRoles={[USER_ROLES.RM]} />
            <ProtectedRoute path="/product/aif" component={AIF} acceptedRoles={[USER_ROLES.RM]} />
          </Switch>
        </Route>
        <ProtectedRoute
          path="/investors"
          component={InvestorDashboard}
          acceptedRoles={[USER_ROLES.RM]}
        />
        <ProtectedRoute
          path="/investor-details"
          component={InvestorDetails}
          acceptedRoles={[USER_ROLES.RM]}
        />
        <ProtectedRoute
          path="/risk-assessment"
          component={RiskAssessmentProfile}
          acceptedRoles={[USER_ROLES.RM]}
        />
        <ProtectedRoute
          path="/total-rm-detail"
          component={TotalRmDetail}
          acceptedRoles={[USER_ROLES.RM]}
        />
        <ProtectedRoute
          path="/book-size-detail"
          component={BookSizeDetail}
          acceptedRoles={[USER_ROLES.RM]}
        />
        <ProtectedRoute path="/net-sales" component={NetSales} acceptedRoles={[USER_ROLES.RM]} />
        <ProtectedRoute path="/total-revenue" component={TotalRevenue} acceptedRoles={[USER_ROLES.RM]} />
        <ProtectedRoute path="/investor-transactions" component={InvestorTransactions} acceptedRoles={[USER_ROLES.RM]} />
        <ProtectedRoute path="/recommended-schemes" component={RecommendedSchemes} acceptedRoles={[USER_ROLES.RM]} />
        <ProtectedRoute path="/holdings" component={Holding} acceptedRoles={[USER_ROLES.RM]} />
        <ProtectedRoute path="/orders" component={Orders} acceptedRoles={[USER_ROLES.RM]} />
        <ProtectedRoute path="/SIP_Lumpsum" component={SIPLumpsum} acceptedRoles={[USER_ROLES.RM]} />
        <ProtectedRoute path="/STP_SWP" component={STP_SWP} acceptedRoles={[USER_ROLES.RM]} />
        <ProtectedRoute path="/Switch" component={SwitchComp} acceptedRoles={[USER_ROLES.RM]} />
        <ProtectedRoute path="/Redeem" component={Redeem} acceptedRoles={[USER_ROLES.RM]} />
        <ProtectedRoute path="/mandates" component={Mandates} acceptedRoles={[USER_ROLES.RM]} />

        <ProtectedRoute
          path="/gross-sales"
          component={GrossSales}
          acceptedRoles={[USER_ROLES.RM]}
        />
        <ProtectedRoute
          path="/applications"
          component={Investors}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
          ]}
        />
        <ProtectedRoute
          path="/onboarding"
          component={OnboardingRouter}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
            USER_ROLES.AMCAPPROVER,
          ]}
        />
        <ProtectedRoute
          path="/application"
          component={ApplicationRoutes}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
          ]}
        />
        <ProtectedRoute
          path="/non-individual-application"
          component={NonIndividualApplicationRoutes}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
          ]}
        />
        <ProtectedRoute
          path="/profile"
          component={Profile}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
          ]}
        />
        <ProtectedRoute
          path="/application-details/:id"
          component={ApplicationDetails}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
            USER_ROLES.POAAPPROVER,
            USER_ROLES.AMCAPPROVER,
          ]}
        />
        <ProtectedRoute
          path="/funds-setup"
          component={FundsSetup}
          acceptedRoles={[USER_ROLES.AMC_ADMIN]}
        />
        <ProtectedRoute
          path="/risk-profile"
          component={RiskProfile}
          acceptedRoles={[USER_ROLES.AMC_ADMIN]}
        />
        <ProtectedRoute
          path="/amc-admins"
          component={AMCAdminsList}
          acceptedRoles={[USER_ROLES.SUPER_ADMIN, USER_ROLES.DISTRIBUTOR]}
        />
        <ProtectedRoute
          path="/reports"
          component={Reports}
          acceptedRoles={[USER_ROLES.AMC_ADMIN]}
        />
        <ProtectedRoute
          path="/applications-list"
          component={ApplicationEsignList}
          acceptedRoles={[
            USER_ROLES.TRUSTEE,
            USER_ROLES.FUND_MANAGER,
            USER_ROLES.POAAPPROVER,
            USER_ROLES.AMCAPPROVER,
          ]}
        />
        <ProtectedRoute
          path="/user-management"
          component={UserManagementLayOut}
          acceptedRoles={[USER_ROLES.AMC_ADMIN]}
        />
        <ProtectedRoute
          path="/non-individual-application-details/:id"
          component={NonIndividualApplicationDetail}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
            USER_ROLES.AMCAPPROVER,
          ]}
        />
        <ProtectedRoute
          path="/non-individual-application-edit"
          component={NonIndividualApplicationEdit}
          acceptedRoles={[USER_ROLES.AMCAPPROVER]}
        />
        <ProtectedRoute
          path="/application-preview/:id"
          component={ApplicationDetails}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
          ]}
        />
        <ProtectedRoute
          path="/non-individual-application-preview/:id"
          component={NonIndividualApplicationDetail}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
          ]}
        />
        <Route path="/investment-details" component={InvestorRoutes} />
        <Route path="/investor-consent/:verificationToken" component={ConsentEmailApproveReject} />
        <Route path="/investor-consent-approved" component={ConsentEmailApprove} />
        <Route path="/investor-consent-reject" component={ConsentEmailReject} />
        <Route path="/assessment/investor-login/:encryptedData" component={investorRiskLogin} />
        <Route path="/investor-otp" component={InvestorRiskMobileOtp} />
        <Route path="/investor-risk-profiledetails" component={RiskProfilePage} />
        <Route path="/investor-risk-preference" component={InvestmentPreferenceRisk} />
        <Route path="/completion-page" component={FinalPage} />

        <ProtectedRoute
          path="/view-consent-email-list"
          component={ConsentEmailApplicationsList}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
            USER_ROLES.AMCAPPROVER,
          ]}
        />
        <ProtectedRoute
          path="/admin-support"
          component={adminSupport}
          acceptedRoles={[USER_ROLES.AMC_ADMIN]}
        />
        <ProtectedRoute
          path="/document"
          component={documentDownload}
          acceptedRoles={[USER_ROLES.RM]}
        />
        <Route path="/">
          <Switch>
            <ProtectedRoute
              exact
              path="/investor"
              component={IndividualInvestor}
              acceptedRoles={[USER_ROLES.RM]}
            />
            <ProtectedRoute
              path="/investor-reports"
              component={InvestorReportRoute}
              acceptedRoles={[USER_ROLES.RM]}
            />
            <ProtectedRoute
              path="/downloads"
              component={DashboardReportRoute}
              acceptedRoles={[USER_ROLES.RM]}
            />
            <ProtectedRoute
              path="/investor/mutual-fund"
              component={ProductDetails}
              acceptedRoles={[USER_ROLES.RM]}
            />
            <ProtectedRoute
              path="/investor/direct-equity"
              component={DirectEquity}
              acceptedRoles={[USER_ROLES.RM]}
            />
            <ProtectedRoute path="/investor/pms" component={PMS} acceptedRoles={[USER_ROLES.RM]} />
            <ProtectedRoute path="/investor/aif" component={AIF} acceptedRoles={[USER_ROLES.RM]} />
            <ProtectedRoute path="/investor/bonds" component={Bonds} acceptedRoles={[USER_ROLES.RM]} />
          </Switch>
        </Route>
        <LoginRequireRoute path="*" />
      </Switch>
    </Router>
  );
}

export default AppRoutes;
